<template>
  <!--      开始视频面试-->
  <el-dialog title="开始面试" width="360px" :visible.sync="hide" :before-close="handClose" class="bg_video">
    <div class="or">
      <img :src="images" :alt="images" :title="images">
    </div>
    <div class="tip">
      约定视频面试前10分钟可扫描二维码进入面试间
    </div>
    <div class="footer" slot="footer">
      <el-button type="primary" @click="handClose">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "videoInvitation",
  props:{
    hide:Boolean,
    id:''
  },
  data(){
    return{
      images:'',
    }
  },
  methods:{
   async init(id){
     await this.$axios.get('/api/app-jycy-henan/henan/video/reservation/url',{id:id}).then(res =>{
        if (res.data.success){
          this.images = res.data.msg;
        }else{
          this.isHide = false;
          this.images = require('@/static/public/times.gif');
        }
      })
    },
    handClose(){
      this.$emit('close',false)
    },

  },
  created() {
  }
}
</script>

<style lang="less" scoped>
//开始视频面试
.bg_video{
  text-align: center;
  .or{
    img{
      width: 124px;
      height: 124px;
      //background: rgba(0,0,0,.3);
    }
  }
  .tip{
    margin-top: 10px;
  }
  .footer{
    text-align: center;
    .el-button{
      width: 200px;
    }
  }
}
</style>